import { IBaseDataParser } from "../../../../vendor_core/core/src/server/parsers/IBaseDataParser";
import BURJackpotsModel from "../../models/BURJackpotsModel";
import BURReelsModel from "../../models/BURReelsModel";
import BURGameModel from "../../models/BURGameModel";

export default class BURInitDataParser implements IBaseDataParser<{}> {
    check(data: any): boolean {
        return data?.data?.gameData?.meterConfig;
    }

    parse(data: any): {} | {}[] {
        const initData = data.data.gameData;

        // Game rtp
        BURGameModel.setGameRtp(initData.gameRTP);

        // Bet
        const bets = initData.betPerLine;
        BURGameModel.setMinBet(bets[0]);
        BURGameModel.setMaxBet(bets[bets.length - 1]);

        // Meters config
        BURReelsModel.setMeterConfig(initData.meterConfig);

        // Meters state
        BURReelsModel.setMeterState(initData.userState);

        // Jackpots config
        BURJackpotsModel.setJackpotsConfig(initData.jackpots);

        return [];
    }
}
